// extracted by mini-css-extract-plugin
export default {"OkdConsoleLink":"OkdConsoleLink_OkdConsoleLink__BDvpO","ConsoleLink":"OkdConsoleLink_ConsoleLink__bIH36"};